module.exports = "<table class=\"table-col-2\" cellspacing=\"0\" width=\"100%\" datatable=\"ng\" dt-options=\"reportCtrl.DataTableService.overviewSettings\">\n\t<thead>\n\t\t<tr>\n\t\t\t<th></th>\n\t\t\t<th>Pax</th>\n\t\t\t<th></th>\n\t\t</tr>\n\t</thead>\n\t<tbody>\n\t\t<tr ng-repeat=\"row in reportCtrl.DataTableService.combinedData\">\n\t\t\t<td>{{ row[0] }}</td>\n\t\t\t<td>{{ row[1] }}</td>\n\t\t\t<td class=\"text-right\"><button ng-click=\"appCtrl.modal = true; reportCtrl.getOverviewData(row[0]);\"><i class=\"fa fa-line-chart\"></i></button></td>\n\t\t</tr>\n\t</tbody>\n</table>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./resources/views/html/overview-base-table.html
 ** module id = 174
 ** module chunks = 0
 **/